import { useEffect, useState } from "react";
import { X } from "lucide-react";
import AppStoreBadges from "@/components/landing/AppStoreBadges";

const STORAGE_KEY = "piefolio_retirement_sticky_dismissed";

interface Props {
  /** Location identifier used as utm_source on the App Store / Play links. */
  location: string;
}

const RetirementStickyBanner = ({ location }: Props) => {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) setHidden(false);
  }, []);

  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* no-op */
    }
  };

  if (hidden) return null;

  return (
    <div
      role="complementary"
      aria-label="Download PieFolio"
      className="fixed bottom-0 inset-x-0 z-40 border-t border-border bg-background/95 backdrop-blur-xl shadow-[0_-8px_30px_-12px_rgba(0,0,0,0.25)]"
    >
      <div className="container mx-auto max-w-6xl px-3 sm:px-6 py-2.5 sm:py-3 flex items-center gap-3 sm:gap-5">
        <button
          onClick={dismiss}
          aria-label="Dismiss download banner"
          className="shrink-0 p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-foreground/5 transition"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex-1 min-w-0">
          <p className="text-sm sm:text-base font-bold text-foreground leading-tight truncate sm:whitespace-normal">
            Track your path to financial freedom effortlessly.
          </p>
          <p className="hidden sm:block text-xs sm:text-sm text-muted-foreground leading-tight mt-0.5">
            Download PieFolio for iOS &amp; Android.
          </p>
        </div>

        <div className="shrink-0">
          <AppStoreBadges
            size="sm"
            variant="dark"
            location={location}
            utmCampaign="retirement_hub"
          />
        </div>
      </div>
    </div>
  );
};

export default RetirementStickyBanner;
